import { render, staticRenderFns } from "./modalFiltroHistorico.vue?vue&type=template&id=4dec0dea&scoped=true&"
import script from "./modalFiltroHistorico.vue?vue&type=script&lang=js&"
export * from "./modalFiltroHistorico.vue?vue&type=script&lang=js&"
import style0 from "./modalFiltroHistorico.vue?vue&type=style&index=0&id=4dec0dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec0dea",
  null
  
)

export default component.exports